import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Estudo } from './estudo';
import { GrupoFamiliar } from '../grupo-familiar/grupo-familiar';
import { GrupoFamiliarService } from '../grupo-familiar/grupo-familiar.service';
import { EstudoService } from './estudo.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { SituacaoEnum } from '../util/situacao.enum';

@Component({
  templateUrl: './conclusao-detail.component.html',
  selector: 'conclusao-detail'
})
export class ConclusaoDetailComponent implements OnInit {
  @Input()
  estudo: Estudo;
  @Input()
  ehAluno: boolean;
  public resposta: Resposta;
  public isLoading: boolean = false;
  public mensagemTela: string;
  public mensagemTelaErro: string;
  public mensagemErros: string[];
  public podeConcluir: boolean;
  public checked: boolean = false;
  public naoConcluiu: boolean = true; // quando clica no concluir, fica fazendo uma validacao bem demorada. Pro kra nao clicar novamente, eu escondo o concluir.
  public concluindoFinalizado: boolean; // quando clica no concluir, fica fazendo uma validacao bem demorada. Pro kra nao clicar novamente, eu escondo o concluir.
  // Emite o estudo apos a conclusao
  @Output()
  estudoEmitido: EventEmitter<Estudo> = new EventEmitter<Estudo>();
  @Output()
  anteriorEmitido: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    private estudoService: EstudoService,
    private mensagem: MatSnackBar,
    private respostaService: RespostaListaDinamicaService,
    private grupoFamiliarService: GrupoFamiliarService
  ) {}

  ngOnInit() {
    if (this.estudo) {
      if (
        this.estudo.situacao === SituacaoEnum.EmAnalise ||
        this.estudo.situacao === SituacaoEnum.Homologado ||
        this.estudo.situacao === SituacaoEnum.Pontuado
      ) {
        this.carregaMensagemConcluido();
      } else {
        if (!this.estudo.respostaQuestionarioPreliminar) {
          this.mensagemTelaErro =
            'Primeiro você deve preencher o formulário: 2.Estudo Preliminar ';
          this.podeConcluir = false;
        } else if (!this.estudo.respostaQuestionarioDadosPessoais) {
          this.mensagemTelaErro =
            'Primeiro você deve \'Salvar e Concluir\' os formulários da seção \'3.Dados Pessoais\' ';
          this.podeConcluir = false;
        } else {
          this.carregaRespostaDadosPessoais(
            this.estudo.respostaQuestionarioDadosPessoais
          );
        }
      }
    }
  }

  carregaRespostaDadosPessoais(idDadosPessoais: number) {
    this.isLoading = true;
    this.respostaService.getRespostaPorId(idDadosPessoais).subscribe(
      result => {
        if (result.situacao === SituacaoEnum.NaoConcluido) {
          this.mensagemTelaErro =
            'Primeiro você deve preencher Salvar e Concluir o formulário: 3.Dados Pessoais ';
          this.podeConcluir = false;
          this.isLoading = false;
        } else {
          // se ele concluiu, tenho que ver se cadastrou a qtd de membros corretamente
          this.carregaRespostaQtdMembros(idDadosPessoais);
        }
      },
      error => this.erro(error)
    );
  }

  carregaRespostaQtdMembros(idDadosPessoais: number) {
    this.respostaService
      .getRespostaPorNomeUnico(idDadosPessoais, 'socioeconomico_qtd_membros')
      .subscribe(
        (resultQtd: string) => {
          const membrosCadastrados = Number(resultQtd);
          this.carregaQtdMembrosCadastrados(membrosCadastrados);
        },
        error => this.erro(error)
      );
  }

  carregaQtdMembrosCadastrados(membrosCadastrados: number) {
    const filtro: GrupoFamiliar = new GrupoFamiliar();
    filtro.codigoEstudoSocioEconomico = this.estudo.id;
    this.grupoFamiliarService.filtrar(filtro).subscribe(
      (result: GrupoFamiliar[]) => {
        if (result.length < membrosCadastrados) {
          this.podeConcluir = false;
          if (membrosCadastrados === SituacaoEnum.NaoConcluido) {
            this.mensagemTelaErro =
              'Você deve cadastrar ' +
              membrosCadastrados +
              ' membro do grupo familiar na seção 4. Dados do Grupo Familiar.';
          } else {
            this.mensagemTelaErro =
              'Você deve cadastrar ' +
              membrosCadastrados +
              ' membros do grupo familiar na seção 4. Dados do Grupo Familiar.';
          }
        } else {
          if (
            this.estudo.situacao === SituacaoEnum.NaoConcluido ||
            this.estudo.situacao === SituacaoEnum.ParaCorrecao
          ) {
            this.podeConcluir = true;
          } else {
            this.podeConcluir = false;
            this.carregaMensagemConcluido();
          }
        }
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  carregaMensagemConcluido() {
    if (this.estudo.situacao === SituacaoEnum.Pontuado) {
      this.mensagemTela = 'Seu estudo foi concluído e pontuado.';
    } else if (this.estudo.situacao === SituacaoEnum.Corrigido) {
      this.mensagemTela =
        'Seu estudo foi marcado como corrigido e será analisado.';
    } else if (this.estudo.situacao !== SituacaoEnum.NaoConcluido) {
      this.mensagemTela = 'Seu estudo foi concluído e será analisado.';
    }
  }

  concluir() {
    this.naoConcluiu = false;
    this.concluindoFinalizado = false;
    this.estudoService.concluir(this.estudo).subscribe(
      result => {
        this.concluindoFinalizado = true;
        this.estudo = result;
        this.podeConcluir = false;
        this.carregaMensagemConcluido();
        this.estudoEmitido.emit(this.estudo);
        this.isLoading = false;
      },
      error => {
        this.concluindoFinalizado = true;
        this.mensagemErros = new Array();
        if (error instanceof Array) {
          for (const entry of error) {
            this.mensagemErros.push(entry);
          }
        } else {
          this.mensagemTelaErro = 'Existem pendências no seu questionário: ' + error;
          // this.mensagemTela = error;
        }

        this.podeConcluir = false;
        this.isLoading = false;
      }
    );
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }

  anterior() {
    this.anteriorEmitido.emit(5);
  }
}
